module.exports = __webpack_public_path__ + "static/media/simply-io.174ecc2e.jpg";